export default "/_next/static/sounds/mum_voicemail-5f5f6c11bbbc54bcce34ccf2419bda71.mp3";